import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../components/ui/Button';

const AccessDenied = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4">
      <div className="max-w-lg w-full bg-card border border-border rounded-2xl p-8 text-center">
        <h1 className="text-2xl font-bold text-foreground mb-2">Access denied</h1>
        <p className="text-muted-foreground mb-6">
          You are logged in, but this account does not have access to the requested restaurant.
        </p>
        <div className="flex items-center justify-center gap-3">
          <Button variant="outline" onClick={() => navigate('/')}>Back to menu</Button>
          <Button onClick={() => navigate('/restaurant-admin-dashboard')}>Restaurant dashboard</Button>
        </div>
      </div>
    </div>
  );
};

export default AccessDenied;
